import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M15.61 7.41L14.2 6l-6 6 6 6 1.41-1.41L11.03 12l4.58-4.59z"
}), 'NavigateBeforeOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/NavigateBeforeOutlined.js
// module id = 4992
// module chunks = 2